

import { AddShippingDetailsController } from "./controllers/addShippingDetailsController";
import '../consigneeSearch/consigneeSearchDirective';

import '../../../requestDetailEdit/models/requestConsignee';
import '../../../requestDetailEdit/models/requestShipment';
import './templates/addShippingDetails.scss'
export function addShippingDetailsDirective(): ng.IDirective {
    return <ng.IDirective>{
        template: require("./templates/addShippingDetails.html"),
        controller: AddShippingDetailsController,
        controllerAs: "vm",
        bindToController: {
            requestDetailEdit: "=",
            isLoading : "=",
            isValid: "=",
            onClickCheck: "=",
            onClickMessage: "="
        },
        scope: true
    }
}

angular
    .module("deliveryCreate.app")
    .directive("addShippingDetails", addShippingDetailsDirective);



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/addRequest/directives/addShippingDetails/addShippingDetailsDirective.ts
 **/